module.exports = __webpack_public_path__ + "static/media/tile-chip-seq.53def386.svg";